export default {
  "site.name": "麻将在线玩",
  "site.slogan": "免费畅玩正宗麻将游戏",
  "nav.home": "首页",
  "nav.categories": "玩法分类",
  "nav.articles": "麻将文章",
  "nav.about": "关于我们",
  "footer.copyright": "© 2026 麻将在线玩 版权所有",
  "footer.description": "麻将在线玩致力于为广大麻将爱好者提供最优质的在线麻将体验。支持国标麻将、四川麻将、广东麻将等多种玩法，随时随地畅享麻将乐趣。",
  "footer.quickLinks": "快速链接",
  "footer.categories": "玩法分类",
  "footer.contact": "联系我们",
  "breadcrumb.home": "首页",
  "scrollToTop": "回到顶部",
  "article.readMore": "阅读全文",
  "article.publishedAt": "发布时间",
  "article.relatedArticles": "相关文章",
  "category.allCategories": "全部分类",
  "category.articlesCount": "篇文章",
  "about.title": "关于我们",
  "about.brandIntro": "品牌介绍",
  "about.reputation": "信誉保障",
  "about.contact": "联系方式",
  "faq.title": "常见问题",
  "cta.title": "立即开始免费畅玩麻将",
  "cta.subtitle": "无需下载，打开即玩，随时随地享受正宗麻将乐趣",
  "cta.button": "开始玩麻将",
  "hero.title": "麻将在线玩",
  "hero.subtitle": "免费畅玩正宗麻将游戏，随时随地与真人对战",
  "hero.description": "支持国标麻将、四川麻将、广东麻将等多种玩法，无需下载，打开即玩",
  "hero.cta": "立即体验",
  "gameTypes.title": "热门麻将玩法",
  "gameTypes.guobiao": "国标麻将",
  "gameTypes.guobiaoDesc": "中国官方竞赛标准，144张牌，81个番种，最具竞技性的麻将玩法",
  "gameTypes.sichuan": "四川麻将",
  "gameTypes.sichuanDesc": "血战到底，刮风下雨，独特的缺一门规则让游戏更加刺激有趣",
  "gameTypes.guangdong": "广东麻将",
  "gameTypes.guangdongDesc": "鸡平胡、推倒胡等多种变体，简单易学，节奏明快，深受大众喜爱",
  "featuredArticles.title": "精选麻将文章",
  "featuredArticles.viewAll": "查看全部文章",
};